













































































































































import Vue from "vue";
import { ref, onMounted, onBeforeUnmount, watch } from "@vue/composition-api";
import { onTouchOutsideElms } from "@/common/dom.functions";
import { emptyFn } from "@/fp";
const rand_id = () => Math.floor(Math.random() * 10000000);
export default Vue.extend({
  props: [
    "items",
    "value",
    "disable",
    "label",
    "info",
    "capitalize",
    "selected_icon",
  ],
  setup(props, { emit }) {
    const box_id = ref("");
    const is_open = ref(false);
    const dd_id = "id_" + rand_id();
    const is_overflow_y = ref(false);

    const subs = {
      watcher: emptyFn(),
      touch_outside: emptyFn(),
    };

    const on_select = (item: any) => {
      // @ts-ignore
      if (item.is_category || item.id === props.value.id) {
        return;
      }
      console.log("item selected : ", item);
      emit("input", item);
      is_open.value = false;
    };

    subs.watcher = watch(is_open, (is_it) => {
      if (is_it) {
        subs.touch_outside = onTouchOutsideElms(() => {
          if (is_open.value) {
            is_open.value = false;
          }
        })(() => [
          document.querySelector("#" + box_id.value) as Element,
          document.querySelector("#" + dd_id) as Element,
        ]);

        // detect if under page
        // Yes ? => open to Top instead of bottom

        const dropdown_box_el = document.querySelector("#" + box_id.value);
        if (dropdown_box_el) {
          const { bottom } = dropdown_box_el.getBoundingClientRect();
          console.log("dropdown_box_el , ", bottom, innerHeight);
          is_overflow_y.value = bottom > innerHeight + 10;
        }
      } else {
        is_overflow_y.value = false;
        subs.touch_outside();
      }
    });

    onMounted(() => {
      box_id.value = "id_" + Date.now();
    });

    onBeforeUnmount(() => Object.values(subs).forEach((ubsub) => ubsub()));

    return { is_open, box_id, on_select, dd_id, is_overflow_y };
  },
});
